import { render, staticRenderFns } from "./SectionCreateNewQuote.vue?vue&type=template&id=94da5b12&"
import script from "./SectionCreateNewQuote.vue?vue&type=script&lang=js&"
export * from "./SectionCreateNewQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports